import { Mail } from 'lucide-react';
import Container from '../ui/Container';

export default function OpenPositions() {
  return (
    <section className="bg-brown-50 py-16">
      <Container>
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">We're Currently Not Hiring</h2>
          <p className="text-gray-600 mb-8">
            While there are no open positions at the moment, we are always eager to connect with talented professionals and ambitious students.
          </p>

          <div className="space-y-8">
            <div className="bg-white p-6 rounded-lg shadow-sm text-left">
              <h3 className="text-xl font-semibold mb-3">Seeking Employment?</h3>
              <p className="text-gray-600 mb-4">
                Send your CV and a cover letter to be considered for future opportunities.
              </p>
              <a 
                href="mailto:careers@bncafricaholdings.com"
                className="inline-flex items-center text-brown-600 hover:text-brown-700"
              >
                <Mail className="w-5 h-5 mr-2" />
                careers@bncafricaholdings.com
              </a>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-sm text-left">
              <h3 className="text-xl font-semibold mb-3">Students and Recent Graduates</h3>
              <p className="text-gray-600 mb-4">
                Interested in gaining hands-on experience? Our internship program offers a chance to work on real-world projects and grow with us. Submit your CV and a brief letter explaining your goals.
              </p>
              <a 
                href="mailto:careers@bncafricaholdings.com"
                className="inline-flex items-center text-brown-600 hover:text-brown-700"
              >
                <Mail className="w-5 h-5 mr-2" />
                careers@bncafricaholdings.com
              </a>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
}